import { render, staticRenderFns } from "./trainAdminData.vue?vue&type=template&id=0ca981b3&scoped=true"
import script from "./trainAdminData.vue?vue&type=script&lang=js"
export * from "./trainAdminData.vue?vue&type=script&lang=js"
import style0 from "./trainAdminData.vue?vue&type=style&index=0&id=0ca981b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca981b3",
  null
  
)

export default component.exports